import clsx from 'clsx';
import { Box, Grid } from '@mui/material';

import ListRefreshButton from '../../../buttons/ListRefreshButton';
import Search from '../../../filter/Search';
import Pagination from '../../../filter/Pagination';
import PaginationOrder from '../../../filter/PaginationOrder';
import SelectAllItemsCheckbox from '../../../buttons/SelectAllItemsCheckbox';

import { type PaginationBaseProps } from './ViewPagination';
import PaginationButtons from './PaginationButtons';

export default function TabletPagination(props: PaginationBaseProps) {
	const { filterProps, orderProps, paginatorProps } = props.paginationProps;

	return (
		<Box className={clsx('p-8', props.className)}>
			<Grid container spacing={1}>
				{(props.showFilters || (props.showOrder && props.visibleOrderFilters)) && (
					<Grid size={12}>
						<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
							{props.showFilters && filterProps && (
								<Grid size="grow">
									<Search
										module={props.module}
										filters={filterProps.filters}
										handleFilterChange={filterProps.handleFilterChange}
										handleFiltersApply={filterProps.handleFiltersApply}
									/>
								</Grid>
							)}
							{props.showOrder && props.visibleOrderFilters && (
								<Grid>
									<PaginationOrder module={props.module} {...orderProps} />
								</Grid>
							)}
						</Grid>
					</Grid>
				)}
				<Grid size={12}>
					<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
						<Grid>
							<Grid container alignItems="center" spacing={1}>
								{props.isSelecting && (
									<Grid>
										<SelectAllItemsCheckbox selectedItems={props.selectedItems} />
									</Grid>
								)}
								<Grid>
									<ListRefreshButton
										isLoading={paginatorProps.isLoading}
										updateRefresh={props.updateRefresh}
									/>
								</Grid>
								<Grid>
									<PaginationButtons
										module={props.module}
										filterProps={filterProps}
										visibleFilters={props.visibleFilters}
										additionalButtons={props.additionalButtons}
										showFilters={props.showFilters}
										showExportButton={props.showExportButton}
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid>
							<Pagination {...paginatorProps} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}
